export const interventionTypes: {
  APPLICATIONS: string
  OPERATIONS: string
  FOODSAFETY: string
} = {
  APPLICATIONS: 'applications',
  OPERATIONS: 'operations',
  FOODSAFETY: 'foodSafety',
}
